import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { AdminSubPage } from "@/components/admin/AdminSubPage";
import { ArticleForm } from "@/components/admin/ArticlesAdmin";

export default function AdminArticleEdit() {
  const { id } = useParams();
  const nav = useNavigate();
  const isNew = id === "baru";
  const [article, setArticle] = useState(isNew ? {} : null);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    api.get("/admin/articles").then((r) => {
      const list = Array.isArray(r.data) ? r.data : [];
      setCategories([...new Set(list.map((a) => a.category).filter(Boolean))]);
    }).catch(() => {});
    if (isNew) return;
    api.get(`/admin/articles/${id}`).then((r) => setArticle(r.data)).catch(() => setArticle(false));
  }, [id, isNew]);
  const back = () => nav("/tigasatu/artikel");
  return (
    <AdminSubPage testId="admin-article-edit-page" back="/tigasatu/artikel" backLabel="Semua artikel" title={isNew ? "Artikel baru" : "Edit artikel"}>
      {article === null ? <p className="text-sm text-zinc-400">Memuat…</p> : null}
      {article === false ? <p className="text-sm text-zinc-400" data-testid="admin-article-notfound">Artikel tidak ditemukan.</p> : null}
      {article ? <ArticleForm key={id} initial={article} categories={categories} onDone={back} onCancel={back} /> : null}
    </AdminSubPage>
  );
}
